import { useAuthStore } from "@/stores/auth-store";
import { api } from "./api-client";

let isChecking = false;

export async function handleSessionExpired(): Promise<void> {
	// Debounce: nur ein Check gleichzeitig
	if (isChecking) return;
	isChecking = true;

	try {
		const response = await api.get<{ status: string }>("/api/v3/user/has-login");
		if (response.status === "success") {
			// Session ist noch gueltig, Seite neu laden
			window.location.reload();
		} else {
			// Session wirklich abgelaufen
			useAuthStore.getState().setShowLoginModal(true);
		}
	} catch {
		// has-login auch fehlgeschlagen -> Login-Modal zeigen
		useAuthStore.getState().setShowLoginModal(true);
	} finally {
		isChecking = false;
	}
}
